import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { EnrollStudentToBatchBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const enrollStudentToBatch = createAsyncThunk<void, EnrollStudentToBatchBody, { extra: Partial<Dependencies> }>(
  "batches/enrollStudentToBatch",
  async (body: EnrollStudentToBatchBody, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.enrollStudent(body);
  },
);

export const resetEnrollStudentToBatch = createAction("batches/resetEnrollStudentToBatch");
